import React from "react";
import { motion } from "framer-motion";

const PostSkeleton = () => {
  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden border border-indigo-100 animate-pulse"
    >
      {/* Header Skeleton */}
      <div className="flex items-center justify-between p-5 border-b border-indigo-100">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 rounded-full bg-gradient-to-r from-indigo-200 to-purple-200"></div>
          <div>
            <div className="h-4 w-32 bg-indigo-200 rounded mb-2"></div>
            <div className="h-3 w-24 bg-indigo-200 rounded"></div>
          </div>
        </div>
        <div className="w-8 h-8 bg-indigo-200 rounded-full"></div>
      </div>
      
      {/* Content Skeleton */}
      <div className="p-5">
        <div className="h-4 bg-indigo-200 rounded mb-3 w-full"></div>
        <div className="h-4 bg-indigo-200 rounded mb-3 w-3/4"></div>
        <div className="h-4 bg-indigo-200 rounded mb-4 w-1/2"></div>
        
        <div className="relative pt-[56.25%] rounded-xl overflow-hidden bg-gradient-to-r from-indigo-100 to-purple-100"></div>
      </div>
      
      {/* Actions Skeleton */}
      <div className="px-5 py-3 border-t border-indigo-100">
        <div className="flex justify-between items-center">
          <div className="h-10 w-20 bg-indigo-200 rounded-lg"></div>
          <div className="h-10 w-24 bg-indigo-200 rounded-lg"></div>
          <div className="h-10 w-20 bg-indigo-200 rounded-lg"></div>
        </div>
      </div>
    </motion.div>
  );
};

export default PostSkeleton;